export default "__VITE_ASSET__CCXqTSOC__"